import React from "react";
import { FormSectionElements, ProgramContainer } from "../../../entities/formTemplateDataType";
import { useEffect } from "react";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import { getRootComponent } from "../../../utilities/ElementUtils";
import { ModalComponent } from "../ModalComponent";
import EhocmAdminApprovalDeny from "./EhocmAdminApprovalDeny";

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    callback: (programContainer: ProgramContainer) => void;
    programContainer: ProgramContainer;
    onButtonClick?: (data: any) => any;
}

const AdminRequestModal = ({ field, isEng, callback, programContainer, onButtonClick }: Props) => {
    useEffect(() => {
        if (field.Script) {
            FormValidationUtils.runJavascript(field);
        }
    }, []);

    const onRequestClose= () => { field.Value = null; callback(programContainer); }

    return (
        <ModalComponent
            modalIsOpen={field?.Value === 'Approve' || field.Value === 'Deny'}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={false}
        >
            <>
                {field.LoadBindName?.toLocaleLowerCase() === 'ehocmadminapprovaldeny' && (
                    <EhocmAdminApprovalDeny 
                        token={getRootComponent(field).Profile?.token} 
                        programContainer={getRootComponent(field)} 
                        isEng={isEng} 
                        field={field}
                        onButtonClick={onButtonClick}
                        onRequestClose={onRequestClose}
                    />
                )}
            </>
        </ModalComponent>
    )
}

export default AdminRequestModal;